var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "signup" },
    [
      _c("h1", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("form.SignInWithEmail"))),
      ]),
      _vm._v(" "),
      _c(
        "b-field",
        {
          attrs: {
            label: _vm.$t("common.email"),
            type: _vm.checkEmpty(_vm.errors.email) ? "" : "is-danger",
            message: _vm.checkEmpty(_vm.errors.email)
              ? ""
              : _vm.errors.email[0],
          },
        },
        [
          _c("b-input", {
            attrs: {
              type: "email",
              icon: "envelope",
              "icon-pack": "fas",
              placeholder: _vm.$t("common.email"),
            },
            on: {
              blur: function ($event) {
                return _vm.validate("email")
              },
            },
            model: {
              value: _vm.email,
              callback: function ($$v) {
                _vm.email = $$v
              },
              expression: "email",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "field is-grouped" }, [
        _c("div", { staticClass: "control" }, [
          _c(
            "button",
            {
              staticClass: "button is-link",
              attrs: { disabled: _vm.hasErrors },
              on: { click: _vm.sendEmail },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t(`msg['Send verification email']`))),
              ]),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-paper-plane" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }